import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler, HandlerOf} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Dropdown} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownItem} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {DropdownList} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {RepositionPopoverProps} from '../../../../../../libs/shared/ui/src/components/popovers/repositionPopover';
import {AnswerModel} from '../../../../../models/api/answerModel';
import {useLinkNavigation} from '../../../../common/navigation/useLinkNavigation';

/*
 * Props.
 */

export interface AnswerPreviewDropdownProps extends RepositionPopoverProps {
  onClose: Handler;
  answer: AnswerModel;
}

/*
 * Component.
 */

export const AnswerPreviewDropdown: FC<AnswerPreviewDropdownProps> = (props) => {
  const {navigateToLink} = useLinkNavigation();
  return (
    <Dropdown
      anchor={props.anchor}
      placement={props.placement}
      width={160}
      onRequestClose={() => props.onClose()}
    >
      <DropdownList>
        <DropdownItem onSelect={() => openInSettings(navigateToLink, props.answer)}>
          <DropdownItemContent>
            <Trans id="dropdown-responses-editsettings">Edit in Settings</Trans>
          </DropdownItemContent>
        </DropdownItem>
      </DropdownList>
    </Dropdown>
  );
};

/*
 * Helpers.
 */

function openInSettings(navigate: HandlerOf<string>, answer: AnswerModel) {
  const editUrl = `/settings/${answer.namespace}/answers/edit/${answer.id}/overview`;
  return navigate(editUrl);
}
